import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { Button, Input, InputGroup, InputGroupText, Modal, ModalBody, ModalFooter } from "reactstrap"

export default function PasswordCopyModal(
    {
        password,
        toggle
    }: {
        password: string,
        toggle: () => void
    }
) {
    const {t} = useTranslation(['common'])

    const copyText = useCallback(() => {
        navigator.clipboard.writeText(password);
        toast(t("Copied to clipboard"));
    }, []);

    return (
        <Modal isOpen={password !== undefined} toggle={toggle}>
            <ModalBody>
                <InputGroup>
                    <InputGroupText>{t("Password")}</InputGroupText>
                    <Input type="text" value={password}/>
                    <Button onClick={copyText}>
                        <FontAwesomeIcon icon={faCopy} />
                    </Button>
                </InputGroup>
            </ModalBody>
            <ModalFooter>
                <Button onClick={toggle}>{t("Close")}</Button>
            </ModalFooter>
        </Modal>
    )
}
